// extracted by mini-css-extract-plugin
export default {"card":"CryptoCard_card__RcXIV"};